<template>
  <!--
    入口引导气泡（entryTipRender=custom）
    外壳：AgentTipFrame；文案 / 按钮来自 SDK ENTRY_TIP_SHOW.texts
  -->
  <agent-tip-frame
    :tip-style="tipStyle"
    :assistant-name="assistantName"
    @close="$emit('gotIt')"
  >
    <template #message>
      <span v-html="messageHtml" />
    </template>
    <template #actions>
      <button type="button" class="btn-gotit" @click.stop="$emit('gotIt')">
        {{ gotItBtn }}
      </button>
      <button type="button" class="btn-quiet" @click.stop="$emit('quiet')">
        {{ quietBtn }}
      </button>
    </template>
  </agent-tip-frame>
</template>

<script>
import AgentTipFrame from './AgentTipFrame.vue';

function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function formatHighlight(message, highlight) {
  const safeMsg = escapeHtml(message);
  const safeHi = escapeHtml(highlight);
  if (safeMsg.includes('{highlight}')) {
    return safeMsg.replace(/\{highlight\}/g, `<br>${safeHi}`);
  }
  return safeHi ? `${safeMsg}<br>${safeHi}` : safeMsg;
}

/**
 * EntryGuideTip
 * 事件：
 * - quiet：暂不打扰 → chat.setEntryMode('half')
 * - gotIt：我知道了 / 折叠 → chat.dismissEntryGuideTip()
 */
export default {
  name: 'EntryGuideTip',
  components: { AgentTipFrame },
  props: {
    tipStyle: {
      type: Object,
      default: () => ({})
    },
    assistantName: {
      type: String,
      default: ''
    },
    guideMessage: {
      type: String,
      default: ''
    },
    guideHighlight: {
      type: String,
      default: ''
    },
    quietBtn: {
      type: String,
      default: ''
    },
    gotItBtn: {
      type: String,
      default: ''
    }
  },
  computed: {
    messageHtml() {
      return formatHighlight(this.guideMessage, this.guideHighlight);
    }
  }
};
</script>
